import { createContext } from 'react';

const CurrentThemeContext = createContext({});

export default CurrentThemeContext;
